export const MAX_ATTACHMENTS = 5;
export const MAX_TOTAL_FILE_SIZE = 25 * 1024 * 1024;

export const validateFileSelection = (existingFiles, incomingFiles) => {
  const nextFiles = [...existingFiles, ...incomingFiles];

  if (nextFiles.length > MAX_ATTACHMENTS) {
    return {
      isValid: false,
      error: 'Maximum 5 files allowed.',
    };
  }

  const totalSize = nextFiles.reduce((sum, file) => sum + file.size, 0);
  if (totalSize > MAX_TOTAL_FILE_SIZE) {
    return {
      isValid: false,
      error: 'Total size of files is above 25 MB.',
    };
  }

  return {
    isValid: true,
    files: nextFiles,
  };
};
